<template>
  <div class="ageInformationPopup">
    <div class="ageInformationPopup__content">
      <div class="ageInformationPopup__title">Zakupy dla pełnoletnich</div>
      <p class="ageInformationPopup__desc">Ta kategoria jest tylko dla dorosłych. Idziesz dalej?</p>
      <div class="ageInformationPopup__actions">
        <VButton text="TAK, MAM 18 LAT, IDĘ DALEJ" theme="orange" @click="accept" />
        <VButton text="NIE MAM 18 LAT, REZYGNUJE" theme="purple" @click="cancel" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import VButton from '@/components/VButton';
export default {
  name: 'AgeInformationPopup',
  components: { VButton },
  computed: {
    ...mapState('layout', ['ageInformationPopup']),
  },
  methods: {
    ...mapMutations({
      setAgeInformationPopupShow: 'layout/setAgeInformationPopupShow',
      setAgeInformationPopupAddToCartInfo: 'layout/setAgeInformationPopupAddToCartInfo',
    }),
    ...mapActions({
      storeAddProductToCart: 'cart/addProductToCart',
    }),
    async accept() {
      this.$cookies.set('ageInformationPopup', true, {
        path: '/',
        maxAge: 60 * 60 * 24,
      });

      if (this.ageInformationPopup.addToCartInfo) {
        await this.storeAddProductToCart({
          product: this.ageInformationPopup.addToCartInfo.product,
          count: this.ageInformationPopup.addToCartInfo.count,
          listName: this.ageInformationPopup.addToCartInfo.listName,
        });
        this.setAgeInformationPopupShow(false);
        this.setAgeInformationPopupAddToCartInfo(null);
      } else {
        this.setAgeInformationPopupShow(false);
      }
    },
    cancel() {
      if (this.ageInformationPopup.addToCartInfo) {
        this.setAgeInformationPopupShow(false);
        this.setAgeInformationPopupAddToCartInfo(null);
      } else {
        this.$router.back();
        this.setAgeInformationPopupShow(false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ageInformationPopup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: $zIndexLayer + 1;
  background-color: $cWhite;
  display: flex;
  align-items: center;
  justify-content: center;

  &__content {
    text-align: center;
    padding: 2rem;
  }

  &__title {
    font-size: 2.5rem;
    line-height: 3rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
  }

  &__desc {
    font-size: 1.6rem;
    line-height: 2rem;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
    margin-top: 3rem;
  }
}
</style>
